<template>
  <div class="pc_model-list">
    <div class="pc-model-main">
      <canvas ref="canvas" style="display: none"></canvas>
      <ul class="sclist">
        <li
          class="model-item"
          v-for="(item, i) in productList"
          :key="i"
          @click="goToEvaluate(item.productId)"
        >
          <!-- pc 机型图片信息 -->
          <div class="product-img">
            <!-- :src="item.productLogo" -->
            <el-image
              class="img"
              :src="item.productLogo"
              :alt="item.name"
              lazy
              alt="Image"
              fit="scale-down"
            />

            <div class="product-modal">
              <div>{{ $t('PCModelList.index.646wfv5g0ro0') }}</div>
            </div>
          </div>
          <div class="product-name">
            <div class="over2">
              {{ item.productName }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import watermark from 'watermarkjs';
export default {
  name: 'PCModelList',
  props: {
    productList: Array,
    notInvite: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // modelData: this.productList
    };
  },
  watch: {},
  computed: {},
  methods: {
    onTab(data) {
      this.$emit('onChange', data);
    },
    goToEvaluate(id) {
      const qrcode = this.$route.query.qrCode
      let query = { 
        id, 
        qrcode
      };
      this.$router.push({
        name: 'Property',
        query: query
      });
    },
    addWatermark(imgSrc) {
      const img = new Image();
      img.crossOrigin = 'anonymous'; // 设置跨域属性
      img.onload = () => {
        resolve(img);
      };
      img.src = imgSrc;
      watermark([img, 'https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/eswop.png'])
        .image(watermark.image.lowerRight(0.5))
        .then(imgs => {
          // document.getElementById('container').appendChild(img);
          console.log(imgs);
        });
      return img;
    }
  }
};
</script>

<style scoped lang="less">
.pc_model-list {
  .sclist {
    width: 100%;
    //height: calc(100vh - 45px);
    min-height: 500px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    //overflow-y: scroll;
  }
  .model-item {
    border-radius: 8px;
    width: calc((100% - 80px) / 5);
    min-width: calc((100% - 80px) / 5);
    max-width: calc((100% - 80px) / 5);
    // width: 210px;
    height: 292px;
    background-color: #fff;
    margin: 20px 20px 0 0;
    overflow: hidden;

    .product-img {
      text-align: center;
      .img {
        width: 224px;
        height: 210px;
      }
    }
  }

  .model-item:nth-child(5n) {
    /* 去除第5n个的margin-right */
    margin-right: 0;
  }

  ul li:hover {
    cursor: pointer;
    transform: translateY(-2px);
    box-shadow: 0 5px 8px rgba(0, 0, 0, 0.1);
  }
  li:hover .product-modal {
    display: block;
    top: 0;
  }

  .product-modal {
    display: none;
  }

  .product-modal {
    width: 100%;
    height: 210px;
    //line-height: 210px;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 110%;
    left: 0;
    transition: all 0.3s;
    border-radius: 8px 8px 0 0;
  }
  .product-modal div {
    line-height: 40px;
    margin-top: 85px;
    display: inline-block;
    min-width: 96px;
    height: 40px;
    background-color: #405FFF;
    border-radius: 4px;
    color: #fff;
    font-size: 16px;
    padding: 0 16px;
  }

  .product-name {
    display: flex;
    justify-content: center;
    padding-top: 10px;
    color: #6e6e6e;
    font-size: 16px;
    .over2 {
      width: 182px;
      text-align: center;
    }
  }
}
</style>
